var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4338 13.3696C13.7412 13.3696 13.1797 12.8081 13.1797 12.1155L13.1797 4.50194L2.90589 14.7758C2.41614 15.2655 1.6221 15.2655 1.13236 14.7758C0.642612 14.2861 0.642612 13.492 1.13236 13.0023L11.4062 2.72841L3.79265 2.72841C3.10004 2.72841 2.53858 2.16695 2.53858 1.47434C2.53858 0.781735 3.10004 0.220267 3.79265 0.220267L14.4338 0.220267C14.7664 0.220267 15.0854 0.352392 15.3206 0.587577C15.5558 0.822761 15.6879 1.14174 15.6879 1.47434L15.6879 12.1155C15.6879 12.8081 15.1264 13.3696 14.4338 13.3696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.72ab2743de23d1e1c3f890db3fbd6f29.svg";
export { ForwardRef as ReactComponent };